
    import { Component, Vue } from 'vue-property-decorator'
    import Layout from '@/app/common/components/layout/layout.vue'

    @Component({
        components: { Layout },
        metaInfo() {
            return {
                title: 'Not found'
            }
        }
    })
    export default class NotFound extends Vue {

    }
